import { Navigate, Outlet } from 'react-router';

import { useAuthStore } from '@/store/auth.store';

/** Guards every signed-in-only route, including onboarding. */
export function RequireAuthOutlet() {
	const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

	if (!isAuthenticated) {
		return <Navigate to="/login" replace />;
	}

	return <Outlet />;
}
